module.exports = __webpack_public_path__ + "static/img/3.9e853b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/sp/3.png
// module id = PhUG
// module chunks = 0